import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { theme } from '../../constants/theme';
import { useThemeContext } from '../../hook/useThemeManager';
import { IAudition } from '../../types/global/helper';
import { FONT_ENUM } from '../../types/global/fonts.types';
import { RichTextViewer } from '../Common/RichTextViewer';

export interface IAuditionDetail {
    audition: IAudition;
}

/**
 * Flat "PROJECT DESCRIPTION" block: uppercase heading, rule, body on page bg (no orange-bordered card).
 */
const AuditionDescription: React.FC<IAuditionDetail> = ({ audition }) => {
    const { themeStyle } = useThemeContext();
    const bodyColor = theme[themeStyle].light_gray_text;

    return (
        <Box component="section" sx={{ py: { xs: 1, sm: 2 } }}>
            <Stack direction="row" alignItems="center" gap={0} sx={{ mb: 2.5 }}>
                <Typography
                    sx={{
                        fontFamily: FONT_ENUM.MAIN_BOLD,
                        fontSize: { xs: 15, sm: 16 },
                        color: theme[themeStyle].tag_white,
                        textTransform: 'uppercase',
                        letterSpacing: '0.1em',
                        fontWeight: 800,
                        whiteSpace: 'nowrap',
                        pr: 2,
                    }}>
                    Project Description
                </Typography>
                <Box
                    sx={{
                        flex: 1,
                        height: '1px',
                        bgcolor: themeStyle === 'dark' ? 'rgba(255,255,255,0.14)' : theme[themeStyle].darkGray60,
                        alignSelf: 'center',
                    }}
                />
            </Stack>

            <Box sx={{ minHeight: { xs: 48, sm: 56 } }}>
                <RichTextViewer
                    content={audition.synopsis}
                    textStyle={{
                        fontSize: 15,
                        fontFamily: FONT_ENUM.MAIN_MEDIUM,
                        color: bodyColor,
                        padding: 0,
                        lineHeight: 1.75,
                    }}
                />
            </Box>
        </Box>
    );
};

export { AuditionDescription };
